var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.27271,
    width: 1.45455,
    height: 16,
    rx: 0.727273,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05027 2.08462C2.14231 2.00095 2.26222 1.95459 2.38661 1.95459H9.90909C10.1852 1.95459 10.4091 2.17845 10.4091 2.45459V4.09095C10.4091 4.3671 10.1852 4.59095 9.90909 4.59095H2.38661C2.26222 4.59095 2.14231 4.54459 2.05027 4.46092L1.15027 3.64274C0.932053 3.44436 0.932053 3.10118 1.15027 2.9028L2.05027 2.08462Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9497 8.82456C13.8577 8.90823 13.7378 8.95459 13.6134 8.95459L6.09091 8.95459C5.81477 8.95459 5.59091 8.73073 5.59091 8.45459L5.59091 6.81823C5.59091 6.54208 5.81477 6.31823 6.09091 6.31823L13.6134 6.31823C13.7378 6.31823 13.8577 6.36459 13.9497 6.44826L14.8497 7.26644C15.0679 7.46482 15.0679 7.808 14.8497 8.00638L13.9497 8.82456Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTour);
export default __webpack_public_path__ + "static/media/tour.00d442accb179cdcc24719c08e6b06f1.svg";
export { ForwardRef as ReactComponent };